import { gql } from '@apollo/client';
import { itemsFragment } from '../fragments/items';

export const vipItemsQuery = gql`
  query VipItems($filter: ItemFilter, $limit: Limit!, $offset: Int!) {
    items(filter: $filter, limit: $limit, offset: $offset) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;

export const featuredItemsRowQuery = gql`
  query FeaturedItemsRow($limit: Limit!, $offset: Int!) {
    featuredItems: items(
      filter: { scope: FEATURED }
      limit: $limit
      offset: $offset
    ) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;

export const searchVippedItemsQuery = gql`
  query SearchVippedItems(
    $limit: Limit!
    $filter: ItemFilter
    $sort: ItemSort!
  ) {
    items(limit: $limit, filter: $filter, sort: $sort) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;

export const searchVippedResidencesItemsQuery = gql`
  query SearchVippedResidencesItems(
    $limit: Limit!
    $filter: ItemFilter
    $sort: ItemSort!
  ) {
    items(limit: $limit, filter: $filter, sort: $sort) {
      ...itemFields
    }
  }
  ${itemsFragment}
`;

export const residenceItemsQuery = gql`
  query ResidenceItems(
    $first: Int
    $filter: ItemFilter
    $cursor: String
    $sort: ItemConnectionSort!
  ) {
    itemsConnection(
      first: $first
      after: $cursor
      filter: $filter
      sort: $sort
    ) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...itemFields
        }
      }
    }
  }
  ${itemsFragment}
`;
